import { isCanlan } from '../../../utils/customer-name'

/**
 * SN-8294 — what a user is told when Player Finder has nowhere to save them.
 * A Player Finder profile is stored per competition (the kept per-competition
 * model), so it only makes a player findable as a spare in the competitions
 * they are registered in, whatever team they play for there — the wording
 * must not promise more.
 * Shared by web and mobile so the two stay word-for-word.
 */
/** Tenant brand name as users see it in their invite emails. */
const BRAND_NAME = isCanlan ? 'Canlan Stats' : 'SportNinja'

/**
 * The two ways a player profile comes about, rendered as a bulleted list: a
 * bold `label`, then `body`. The `register` bullet ends with a link to Team
 * Finder whose text is `action`.
 */
export const NO_PLAYER_PROFILE_GUIDANCE = {
  title: 'No Player Profile Associated',
  invite: {
    label: 'Join a Team as a Player',
    body: `Check your email for a ${BRAND_NAME} Invite. If you don't have one, contact your Team Rep or League Admin.`,
  },
  register: {
    label: 'Register',
    body: 'Follow this link to find open registrations for teams in your area',
  },
  action: 'Find a Team',
} as const

/**
 * A preference card saved for no competition: nowhere a team can find the
 * player for that sport yet, so point them to Team Finder.
 */
export const NO_COMPETITIONS_GUIDANCE = {
  body: 'Not saved for any competition yet, so teams cannot find you for this sport. Join a team to get started.',
  action: 'Find a Team',
} as const

/** Adding a Player Finder profile for a sport the player plays nowhere yet. */
export const NOT_IN_A_COMPETITION_GUIDANCE =
  'You are not in a competition for this sport yet. A Player Finder profile is saved per competition, so join a team first: Team Finder lists teams looking for players.'
